import { render } from "./AssetAdmin.vue?vue&type=template&id=1c9f995b&scoped=true"
import script from "./AssetAdmin.vue?vue&type=script&lang=js"
export * from "./AssetAdmin.vue?vue&type=script&lang=js"

import "./AssetAdmin.vue?vue&type=style&index=0&id=1c9f995b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9f995b"]])

export default __exports__